import ApiService from './ApiService';

export default class ProfileApi extends ApiService {
    getUserProfile() {
        return this.get('profile');
    }

    updateUserProfile(payload: any) {
        return this.put('profile', payload);
    }

    updateGroupAdminProfile(payload: any) {
        return this.put('profile/group-admin', payload);
    }
}
